import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';

interface ErrorProps {
    message?: string;
    onRetry?: () => void;
}

const Error: React.FC<ErrorProps> = ({
    message = 'Something went wrong!',
    onRetry,
}) => {
    return (
        <div className="flex flex-col justify-center items-center min-h-[300px]">
            <ExclamationTriangleIcon className="w-16 h-16 text-red-500 mb-4" />
            <p className="text-red-600 text-lg font-medium">{message}</p>
            {onRetry && (
                <button
                    onClick={onRetry}
                    className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
                >
                    Retry
                </button>
            )}
        </div>
    );
};

export default Error;
